import { deriveModified, detach } from "../entities/provenance.js";
// Doc 07 §5 decision table. Detach the deleted template from every associated
// row first, then decide each row's fate from what remains.
export const planTemplateDelete = (templateId, mode, rows) => {
    const actions = rows.map(({ collection, item }) => {
        const provenance = item.provenance;
        // A row without provenance can't be owned by a template — defensively keep it.
        if (provenance == null)
            return { kind: "detachOnly", collection, id: item.id, provenance: emptyProvenance(), templateIds: [] };
        const detached = detach(provenance, item.templateIds, templateId);
        const stillOwned = detached.provenance.templateSources.length > 0 || provenance.createdByImport === false;
        if (stillOwned) {
            return {
                kind: "detachOnly",
                collection,
                id: item.id,
                provenance: detached.provenance,
                templateIds: detached.templateIds,
            };
        }
        // Orphaned (createdByImport && no sources left).
        if (mode === "removeAll")
            return { kind: "delete", collection, id: item.id };
        // removeUnchangedOnly: unchanged ⇒ delete; edited ⇒ keep as independent.
        // Snapshot equality is ground truth, so edit-then-revert reads as unchanged.
        return deriveModified(item)
            ? { kind: "makeIndependent", collection, id: item.id }
            : { kind: "delete", collection, id: item.id };
    });
    return { templateId, actions };
};
const emptyProvenance = () => ({
    templateSources: [],
    createdByImport: false,
    importedSnapshot: { name: "", assignment: { kind: "everyone" } },
    modifiedSinceImport: false,
});
// Counts for the delete dialog: "Removes N; M kept via other templates; K edited."
export const previewTemplateDelete = (templateId, mode, rows) => {
    const { actions } = planTemplateDelete(templateId, mode, rows);
    return {
        removes: actions.filter((a) => a.kind === "delete").length,
        keptViaOtherSource: actions.filter((a) => a.kind === "detachOnly").length,
        keptEdited: actions.filter((a) => a.kind === "makeIndependent").length,
    };
};
//# sourceMappingURL=deleteTemplate.js.map